import { inject as service } from '@ember/service';
import Route from 'cio/routes/base';
import ApiService from 'cio/services/api';
import StartersController from 'cio/pods/layouts/starters/controller';
import LayoutModel from 'cio/models/layout';
import AuthService from 'cio/services/auth';
import Transition from '@ember/routing/-private/transition';

export default class StartersRoute extends Route {
  @service api!: ApiService;
  @service auth!: AuthService;

  crumb() {
    return {
      name: 'Starters',
      path: 'layouts.starters',
    };
  }

  beforeModel(transition: Transition) {
    super.beforeModel(transition);
    if (Boolean(this.auth.hasPermission('journeys/layouts/create')) === false) {
      this.router.transitionTo('layouts.index');
      return;
    }
    return;
  }

  model() {
    return this.get('api').request('layouts?starters=true');
  }

  setupController(controller: StartersController, model: { layouts: LayoutModel[] }) {
    let starterLayouts = model.layouts;

    controller.setProperties({ starterLayouts });
  }
}
